// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nb0_X"};